import React from 'react';
import styled from 'styled-components/macro';
import PageWrap from 'components/GeneralComponents/PageWrap';
import elements from './elements';
import components from './components';
import styledConfirm from '../../Requests/components/styled';
import UpgradePrompt from '../../../components/GeneralComponents/UpgradePrompt/UpgradePrompt';
import Modal from 'components/GeneralComponents/Modal';

const BigWrap = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  height: calc(100% - 40px);
  width:100%;
`;

const TeamFeedWrap = styled(PageWrap)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  overflow: hidden;
  flex: 1 1 auto;
  display: flex;
  padding-top:0px;
`;

class ChatFeedComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      debug: false,
      planName: [],
    };

    this._isMounted = false;
    this.planUrlSet = false;
  }

  componentDidMount() {
    const { apiCalled, fetchChatSessions, locationData, plans, } = this.props;
    if (plans && plans.length > 0) {
      if (locationData && locationData.plan_id) {
        const cplan = plans.find(plan => plan.id === locationData.plan_id);
        this.setState({ planName: cplan.name });
      }
    }

    if (!apiCalled) {
      fetchChatSessions();
    }

    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    const { locationData, plans } = this.props;
    if (plans && plans.length > 0) {
      if (locationData && locationData.plan_id) {
        if (!this.planUrlSet) {
          this.planUrlSet = true;
          const cplan = plans.find(plan => plan.id === locationData.plan_id);
          this.setState({ planName: cplan.name });
        }
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { active } = this.props;
    const { planName } = this.state

    return (
      <BigWrap>
        {/* <components.TopLine /> */}
        <TeamFeedWrap direction="row" full>
          <components.ChatSessions />
          <elements.ColumnWrap>
            {active.chatSession > 0 && <components.ChatMessages />}
          </elements.ColumnWrap>
        </TeamFeedWrap>

        {planName === 'Basic' && <Modal>
          <UpgradePrompt />
        </Modal>}
        <styledConfirm.Overlay display={planName === "Basic" ? 'block' : 'none'} />
      </BigWrap>
    );
  }
}

ChatFeedComponent.propTypes = {
  //locationId: PropTypes.string.isRequired,
};

export default ChatFeedComponent;
